import { BaseModel, createBaseModel } from '../schemas/BaseModel.schema';

export type IBaseModelDataModel = BaseModel;

export function createBaseModelDataModel(overrides: Partial<IBaseModelDataModel> = {}): IBaseModelDataModel {
  return createBaseModel(overrides);
}
